const ApplicationThree = ({work}) => {

    return ( 
        <table className="mt-4">
            <thead>
                <tr>
                    <th>Period From</th>
                    <th>Period To</th>
                    <th>Job Title</th>
                    <th>Employer Name</th>
                    <th>Address</th>
                </tr>
                </thead>
                <tbody>             
                   {
                        work && work.map(item => (
                            <tr key={item.employerName}>
                                <td>{item.fromDate}</td>
                                <td>{item.toDate}</td>
                                <td>{item.occupation}</td>
                                <td>{item.employerName}</td>
                                <td>{item.workAddress}</td>
                            </tr>
                        ))
                    }
            </tbody>
        </table>
     );
}
 
export default ApplicationThree;